import router from '../router'
import axios from 'axios'
import moment from 'moment'
import videojs from 'video.js'
import store from '../store'

export default {

  inAdminPortal() {
    return router.currentRoute.path.startsWith('/admin')
  },

  inSellerPortal() {
    return router.currentRoute.path.startsWith('/portal')
  },

  getCookie(name) {
    var i, x, y, ARRcookies = document.cookie.split(";")
    for (i = 0; i < ARRcookies.length; i++) {
      x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="))
      y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1)
      x = x.replace(/^\s+|\s+$/g, "")
      if (x == name) {
        return y
      }
    }
  },

  shouldGoHome() {
    let goHome = [
      '', 
      'Register',
      'RegisterSuccess',
      'RegisterFail',
      'RegisterExpired',
      'ForgetPassword',
      'ResetPassword',
      'ResetExpired',
      'ResetSuccess',
      'ResetFail',
    ]
    return goHome.includes(store.state.global.prev_page.name)
  },

  goBack() {
    if(this.shouldGoHome()) {
      router.push('/')
    }
    else {
      if(store.state.global.prev_page.force) {
        router.push(store.state.global.prev_page.force.fullPath)
      }
      else {
        router.go(-1)
      }
    }
  },


  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
    })
  },

  urlToBase64(url) {
    // return new Promise((resolve, reject) => {
    //   let xhr = new XMLHttpRequest()
    //   xhr.onload = function() {
    //     let reader = new FileReader()
    //     reader.onload = () => resolve(reader.result)
    //     reader.readAsDataURL(xhr.response)
    //   }
    //   xhr.open('GET', url)
    //   xhr.responseType = 'blob'
    //   xhr.send()
    // })
    return new Promise((resolve, reject) => {
      axios.get(url, {
        responseType: "blob"
      }).then(response => {
        let reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.readAsDataURL(response.data)
      })
    })
  },

  dayDiff(date) {
    return moment().startOf('day').diff(moment(date).startOf('day'), 'days')
  },

  isThisYear(date) {
    var now = new Date()
    var start = new Date(date)
    return now.getFullYear() == start.getFullYear()
  },

  secondsToTime(seconds) {
    let time = moment.utc(seconds * 1000).format('HH:mm:ss')
    let hour = time.split(':')[0]
    let minute = time.split(':')[1]
    let second = time.split(':')[2]
    return hour == '00' ? `${minute}:${second}` : time
  },

  videoSrcWithToken(src) {
    let token = store.state.user.token || store.state.seller.token
    return token && !src.startsWith('blob') ? `${src}?token=${token.split(' ')[1]}` : src
  },

  videoOption(data) {
    let type = {
      'video/mp4': 'video/mp4',
      'video/quicktime': 'video/mp4',
      'video/mpeg': 'video/mp4',
      'application/x-mpegURL': 'application/x-mpegURL',
    }
    data.type = data.type ? type[data.type] : ''
    return {
      autoplay: data.autoplay ? data.autoplay : false,
      muted: data.muted ? data.muted : true,
      loop: data.loop ? data.loop : false,
      controls: data.controls ? data.controls : false,
      loadingSpinner: false,
      preload: data.preload ? data.preload : 'auto',
      aspectRatio: data.aspectRatio ? data.aspectRatio : '7:4',
      bigPlayButton: data.bigPlayButton ? data.bigPlayButton : false,
      fluid: data.fluid !== undefined ? data.fluid : true,
      poster: data.poster ? data.poster : '',
      disableVideoPlayPauseClick: true,
      notSupportedMessages: '該影片暫時無法播放，請稍後再試',
      preferFullWindow: true,
      html5: {
        nativeTextTracks: false,
      },
      sources: data.src ? [{
        type: data.type,
        src: this.videoSrcWithToken(data.src)
      }] : []
    }
  },

  startPlayVideo(refs, i, src) {
    if(!refs[`video${i}`]) {
      return
    }
    let video = refs[`video${i}`][0]
    if(video && video.player) {
      vm.$hover = i
      if(video.player.readyState() >= 2) {
        video.player.play()
      }
      else if(!video.player.currentSrc()) {
        video.player.src(this.videoSrcWithToken(src))
      }
    }
  },

  stopPlayVideo(refs, i) {
    if(!refs[`video${i}`]) {
      return
    }
    let video = refs[`video${i}`][0]
    if(video && video.player) {
      vm.$hover = null
      video.player.pause()
      video.player.hasStarted(false)
      video.player.currentTime(0.1)
    }
  },

  onPlayerCanplay(player, i) {
    vm.$hover == i ? player.play() : ''
  },

  deepCopy(object) {
    return JSON.parse(JSON.stringify(object))
  },

  price2peach(price, type) {
    return type == 'clothes' ? parseInt((price + vm.$SHIPPING_FEE) * vm.$EXCHANGE_RATE) : parseInt(price * vm.$EXCHANGE_RATE)
  },

  peach2price(peach, type) {
    return type == 'clothes' ? parseInt(peach / vm.$EXCHANGE_RATE - vm.$SHIPPING_FEE) : parseInt(peach / vm.$EXCHANGE_RATE)
  },

  toProductPage(id, seller, product_type) {
    if(['photo', 'story'].includes(product_type)) {
      router.push({
        name: 'Story', 
        params: {
          id: id, 
          seller: seller, 
          product_type: product_type
        }
      })
    }
    else if(['video', 'clothes'].includes(product_type)) {
      router.push(`/product/${id}`)
    }
  },

  productImagePreview(product) {
    if (!product || (!product.image_info?.length && !product.video_info?.length)) {
      return ''
    }
    return vm.$HOST_URL + (product.image_info?.[0]?.uuid_path || product.video_info?.[0]?.preview_path || '')
  },

  async fileValidation(file, product_type = null) {
    return new Promise((resolve, reject) => {
      let type = file.type.split('/')[0]
      if(type == 'image') {
        if(file.size > vm.$image_size.max * 1024 * 1024) {
          vm.$root.$emit('alert', 'error', `上傳失敗，檔案過大 (${vm.$image_size.max}MB)`)
          resolve(false)
        }
        resolve(true)
      }
      else if(type == 'video') {
        let video = document.createElement('video')
        video.id = 'upload'
        let upload = videojs(video, this.videoOption({
          src: URL.createObjectURL(file),
          type: file.type
        }))
        upload.one('loadedmetadata', () => {
          if(!(upload.duration() >= vm.$video_duration[product_type].min && upload.duration() <= vm.$video_duration[product_type].max)) {
            let min = vm.$video_duration[product_type].min < 60 ? `${vm.$video_duration[product_type].min}秒` : vm.$video_duration[product_type].min / 60
            let max = vm.$video_duration[product_type].max < 60 ? `${vm.$video_duration[product_type].max}秒` : `${vm.$video_duration[product_type].max / 60}分鐘`
            vm.$root.$emit('alert', 'error', `上傳失敗，影片長度需在${min} - ${max}內`)
            resolve(false)
          }
          resolve(true)
        })
      }
      else {
        vm.$root.$emit('alert', 'error', `上傳失敗，檔案格式錯誤`)
        resolve(false)
      }
    })
  },

  async fileValidationWithDetails(file, product_type = null) {
    return new Promise((resolve) => {
      const errors = []
      let type = file.type.split('/')[0]

      if (type == 'image') {
        if (file.size > vm.$image_size.max * 1024 * 1024) {
          const sizeMB = Math.round(file.size / 1024 / 1024 * 10) / 10
          errors.push(`檔案大小 ${sizeMB}MB 超過限制 (最大 ${vm.$image_size.max}MB)`)
        }
        resolve({ valid: errors.length === 0, errors })
      }
      else if (type == 'video') {
        // 使用原生 HTML5 video 元素驗證，避免 VideoJS 錯誤
        let video = document.createElement('video')
        video.preload = 'metadata'
        const objectUrl = URL.createObjectURL(file)
        video.src = objectUrl

        video.onloadedmetadata = () => {
          const duration = video.duration
          const durationConfig = vm.$video_duration[product_type]

          if (durationConfig) {
            const durationMin = Math.floor(duration / 60)
            const durationSec = Math.floor(duration % 60)
            const currentDuration = durationMin > 0 ? `${durationMin}分${durationSec}秒` : `${durationSec}秒`

            if (duration < durationConfig.min) {
              let minStr = durationConfig.min < 60 ? `${durationConfig.min}秒` : `${durationConfig.min / 60}分鐘`
              errors.push(`影片長度 ${currentDuration} 太短 (最短需 ${minStr})`)
            }
            if (duration > durationConfig.max) {
              let maxStr = durationConfig.max < 60 ? `${durationConfig.max}秒` : `${durationConfig.max / 60}分鐘`
              errors.push(`影片長度 ${currentDuration} 太長 (最長限制 ${maxStr})`)
            }
          }

          // 清理資源
          URL.revokeObjectURL(objectUrl)
          resolve({ valid: errors.length === 0, errors })
        }

        video.onerror = () => {
          errors.push(`影片格式不支援或檔案損壞`)
          URL.revokeObjectURL(objectUrl)
          resolve({ valid: false, errors })
        }
      }
      else {
        errors.push(`不支援的檔案格式: ${file.type || '未知'}`)
        resolve({ valid: false, errors })
      }
    })
  },


}
